const Menu1 = () => {

	const toggleBtn = document.querySelector('#menu-overlay-toggler');
	if(!toggleBtn) {
		return;
	}

	toggleBtn.addEventListener('click', (e) => {
		e.preventDefault();

		if(document.body.classList.contains('has-vbk-animation-step-1')) {
			return;
		}

		document.body.classList.toggle('js-menu-overlay-revealed');
		document.body.classList.remove('has-vbk-animation-step-1');
		document.body.classList.remove('has-vbk-animation-step-2');

		if(document.body.classList.contains('js-menu-overlay-revealed')) {
			toggleBtn.setAttribute('aria-haspopup', 'true');
			toggleBtn.setAttribute('aria-expanded', 'true');
			toggleBtn.setAttribute('aria-label', toggleBtn.dataset.labelOpened);
		}
		else {
			toggleBtn.removeAttribute('aria-haspopup');
			toggleBtn.setAttribute('aria-expanded', 'false');
			toggleBtn.setAttribute('aria-label', toggleBtn.dataset.labelClosed);
		}
	});


	const menuOverlayBackground = document.querySelector('#the-header .bg');
	if(menuOverlayBackground) {
		menuOverlayBackground.addEventListener('click', (e) => {
			e.preventDefault();
			document.body.classList.remove('js-menu-overlay-revealed');
			document.body.classList.remove('has-vbk-animation-step-1');
			document.body.classList.remove('has-vbk-animation-step-2');
			toggleBtn.removeAttribute('aria-haspopup');
			toggleBtn.setAttribute('aria-expanded', 'false');
			toggleBtn.setAttribute('aria-label', toggleBtn.dataset.labelClosed);
		});
	}

	const handleMenuItem1Click = (e) => {
		e.preventDefault();

		document.body.classList.remove('js-menu-overlay-revealed');
		document.body.classList.remove('has-vbk-animation-step-1');
		document.body.classList.remove('has-vbk-animation-step-2');
		toggleBtn.removeAttribute('aria-haspopup');
		toggleBtn.setAttribute('aria-expanded', 'false');
		toggleBtn.setAttribute('aria-label', toggleBtn.dataset.labelClosed);

		const href = e.currentTarget.getAttribute('href');
		setTimeout(() => {
			window.location.href = href;
		}, 280);
	}

	document.querySelectorAll('#menu-1-overlay .menu-item a').forEach(a => a.addEventListener('click', handleMenuItem1Click));
};

export default Menu1;